// eslint-disable-next-line no-unused-vars
import axios from "axios";
// eslint-disable-next-line no-unused-vars
import { ATP_API_URL } from "../apiConfig/apiConfig";

/**
 * Static brand list from API response (API call commented out).
 * Deduplicated and sorted alphabetically.
 * Source: GET /api/partner/v1/dmi/GetBrands
 */
const STATIC_BRANDS = [
  { id: 21, value: "AI+" },
  { id: 22, value: "Amazfit" },
  { id: 12, value: "Apple" },
  { id: 24, value: "Asus" },
  { id: 25, value: "CANNON" },
  { id: 26, value: "CELLECOR" },
  { id: 27, value: "Dell" },
  { id: 28, value: "FIRE BOLT" },
  { id: 29, value: "FUJI FILM" },
  { id: 30, value: "Google" },
  { id: 31, value: "Honor" },
  { id: 32, value: "HP" },
  { id: 33, value: "I TEL" },
  { id: 34, value: "Infinix" },
  { id: 35, value: "Intex" },
  { id: 36, value: "IQOO" },
  { id: 37, value: "Lava" },
  { id: 38, value: "Lenovo" },
  { id: 39, value: "LG" },
  { id: 40, value: "Micromax" },
  { id: 41, value: "Motorola" },
  { id: 42, value: "NOISE" },
  { id: 43, value: "Nokia" },
  { id: 44, value: "NOTHING" },
  { id: 45, value: "OnePlus" },
  { id: 46, value: "Oppo" },
  { id: 47, value: "POCO" },
  { id: 48, value: "Realme" },
  { id: 49, value: "RELIANCE" },
  { id: 50, value: "Samsung" },
  { id: 51, value: "Sony" },
  { id: 52, value: "Tecno" },
  { id: 53, value: "Vivo" },
  { id: 54, value: "Xiaomi" },
];

/**
 * GetBrandsActions
 * Returns the static brand list directly.
 * Uncomment the axios block below to switch back to live API.
 *
 * Returns: { success: true, data: Array<{ id, value }> }
 *        | { success: false, error: string }
 */
export const GetBrandsActions = async () => {
  // ── Live API call (uncomment when ready) ─────────────────────────────────
  // try {
  //   const response = await axios.get(ATP_API_URL.GetBrands, {
  //     headers: { Accept: "application/json, text/plain, */*" },
  //   });
  //   const raw = response.data;
  //   if (!raw.status || !Array.isArray(raw.data)) {
  //     return { success: false, error: "Unexpected response from brands API." };
  //   }
  //   return { success: true, data: raw.data };
  // } catch (error) {
  //   console.error("[GetBrandsActions]", error.message || error);
  //   return {
  //     success: false,
  //     error: error.response?.data?.message || error.message || "Failed to fetch brands.",
  //   };
  // }
  // ─────────────────────────────────────────────────────────────────────────

  return { success: true, data: STATIC_BRANDS };
};
